import { deepCopy } from "../../../../utils/deepCopy";

export const fetchDirectReporteeHeatmapTableStarted = (state, payload) => {
    return {
        ...state,
        directReporteeHeatmapTableApi: {
            isProcessing: true,
            error: false,
            requestId: payload.requestId ? payload.requestId : undefined
        },
        directReporteeSelectedHeaders: payload.data || [],
        directReporteeFilters: payload.filters,
        directReporteeByScore: payload.byScore,
        directReporteeMultipleSelect: payload.multipleSelect,
        directReporteeSelectedUserData: payload.selectedUserData
    }
}

export const fetchDirectReporteeHeatmapTableSuccess = (state, payload) => {
    let heatmapColumns = [];
    let heatmapData = [];
    let heatmapColumnList = []
    let initialLoad = payload.request.initialLoad
    if (payload.data && payload.data.data) {
        heatmapColumns = payload.data.data.columnData;
        heatmapColumnList = payload.data.data.columnList
        heatmapData = payload.data.data.dataMap
        if (payload.request.projectType && payload.request.projectType === "Very_Simple_Survey") {
        } else {
            heatmapData.forEach((item) => {
                if (item.name !== "Responses") {
                    item.children = [];
                    item.key = item.name
                }
            })
        }

    }
    if (state.directReporteeHeatmapTableApi.requestId) {
        if (state.directReporteeHeatmapTableApi.requestId === payload.data.data.requestId) {
            return {
                ...state,
                directReporteeHeatmapTableApi: {
                    ...state.directReporteeHeatmapTableApi,
                    isProcessing: false,
                    error: false,
                    isDesiredRequestMet: true
                    //requestId: undefined
                },
                directReporteeHeatmapColumns: deepCopy(heatmapColumns),
                directReporteeHeatmapData: deepCopy(heatmapData),
                directReporteeHeatmapChildrenList: deepCopy(heatmapColumns),
                directReporteeHeatmapColumnList: deepCopy(heatmapColumnList),
                isDataFetchedDirectReportee: initialLoad ? true : state.isDataFetched
            }
        }
        else {
            return {
                ...state,
                directReporteeHeatmapTableApi: {
                    ...state.directReporteeHeatmapTableApi,
                    isProcessing: state.directReporteeHeatmapTableApi.isDesiredRequestMet ? false : true,
                    error: false,
                    isDesiredRequestMet: false
                    //requestId: undefined
                },
            }
        }


    }
    else {
        return {
            ...state,
            directReporteeHeatmapTableApi: {
                ...state.directReporteeHeatmapTableApi,
                isProcessing: false,
                error: false,
            },
            directReporteeHeatmapColumns: deepCopy(heatmapColumns),
            directReporteeHeatmapData: deepCopy(heatmapData),
            directReporteeHeatmapChildrenList: deepCopy(heatmapColumns),
            directReporteeHeatmapColumnList: deepCopy(heatmapColumnList),
            isDataFetchedDirectReportee: initialLoad ? true : state.isDataFetched
        }
    }
}


export const fetchDirectReporteeHeatmapTableFailed = (state, payload) => {
    return {
        ...state,
        directReporteeHeatmapTableApi: {
            isProcessing: false,
            error: true
        },
        directReporteeHeatmapColumns: [],
        directReporteeHeatmapData: [],
        directReporteeHeatmapChildrenList: [],
        directReporteeHeatmapColumnList: [],
        isDataFetchedDirectReportee: false
    }


}

export const directReporteeUpdateScoreLevel = (state, payload) => {
    return { ...state, directReporteeSelectedScoreLevel: payload.data };
};

export const directReporteeUComparisonLevel = (state, payload) => {
    return { ...state, directReporteeSelectedComparisonLevel: payload.data };
};